import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

export const FETCH_FEEDBACK_REQUEST = 'FETCH_FEEDBACK_REQUEST';
export const FETCH_FEEDBACK_SUCCESS = 'FETCH_FEEDBACK_SUCCESS';
export const FETCH_FEEDBACK_FAILURE = 'FETCH_FEEDBACK_FAILURE';
export const SUBMIT_FEEDBACK_REQUEST = 'SUBMIT_FEEDBACK_REQUEST';
export const SUBMIT_FEEDBACK_SUCCESS = 'SUBMIT_FEEDBACK_SUCCESS';
export const SUBMIT_FEEDBACK_FAILURE = 'SUBMIT_FEEDBACK_FAILURE';

const buildFeedbackUrl = (sessionId, studentId) =>
  buildUrl(`/sessions/${sessionId}/students/${studentId}/feedback`);

export function fetchFeedbackIfNeeded(sessionId, studentId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state,
      { method: 'GET', url: buildFeedbackUrl(sessionId, studentId) }
    )) {
      return false;
    }
    return dispatch(fetchFeedback(sessionId, studentId));
  };
}

export function fetchFeedback(sessionId, studentId) {
  return (dispatch) => {
    const url = buildFeedbackUrl(sessionId, studentId);
    const method = 'GET';

    const promise = dispatch(fetchFeedbackRequest()).payload
      .then((response) => dispatch(fetchFeedbackSuccess(response)))
      .catch((error) => dispatch(fetchFeedbackFailure(error)));

    function fetchFeedbackRequest() {
      return ApiCall.createAction({
        type: FETCH_FEEDBACK_REQUEST,
        payload: fetch(url),
        url,
        method,
        sessionId,
        studentId,
        disableDefault: true,
      });
    }

    function fetchFeedbackSuccess(payload) {
      return ApiCall.createAction({
        type: FETCH_FEEDBACK_SUCCESS,
        payload,
        url,
        method,
        sessionId,
        studentId,
      });
    }

    function fetchFeedbackFailure(error) {
      return ApiCall.createAction({
        type: FETCH_FEEDBACK_FAILURE,
        error,
        url,
        method,
        sessionId,
        studentId,
        disableDefault: true,
      });
    }

    return promise;
  };
}


export const submitFeedback = (sessionId, studentId, payload) => (dispatch) => {
  const url = buildFeedbackUrl(sessionId, studentId);
  const method = 'PUT';
  return dispatch(submitFeedbackRequest()).payload
    .then((response) => dispatch(submitFeedbackSuccess(response)))
    .catch((error) => dispatch(submitFeedbackFailure(error)));

  function submitFeedbackRequest() {
    const request = fetch(url,
      {
        method,
        body: JSON.stringify(payload),
      }
    );
    return ApiCall.createAction({
      type: SUBMIT_FEEDBACK_REQUEST,
      payload: request,
      url,
      method,
    });
  }

  function submitFeedbackSuccess() {
    return ApiCall.createAction({
      type: SUBMIT_FEEDBACK_SUCCESS,
      url,
      method,
    });
  }

  function submitFeedbackFailure(error) {
    return ApiCall.createAction({
      type: SUBMIT_FEEDBACK_FAILURE,
      url,
      method,
      error,
    });
  }
};



// WEBPACK FOOTER //
// ./data/Feedback/actions.js